module.exports = __webpack_public_path__ + "static/img/404.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = 70
// module chunks = 0